import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-radio';

class FormElementRadioGroup extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: row;
                    /* position: relative; */
                    margin-bottom: 8px;
                }
                tmn-radio-group tmn-radio {
                    padding-left: 10px;
                    min-width: 200px;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                }
                tmn-radio-group tmn-radio:first-child {
                    /* border-right: 0; */
                    margin-right: 12px;
                }
            `,
        ];
    }

    render() {
        const { itemTemplate, value } = this;
        const { isOptional, type, options } = itemTemplate;
        const key = this.getKey();

        if (!options?.length) {
            return html`<div>${key} is ${type} but has no options</div>`;
        }
        const dataForOptions = options.map((o) => {
            if (typeof o === 'string' || typeof o === 'number') {
                // turn into an object meeting the appropriate criteria
                return { name: o, displayKey: o.toString() };
            }
            if (!o.name) {
                o.name = o.displayKey;
            }
            if (!o.displayKey) {
                o.displayKey = o.name;
            }
            return o;
        });
        const selectedOption = dataForOptions.find((d) => value === d.name);
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode()) {
            // there are some cases where we can view but not edit
            // in that case we still want to show the selection even though
            // the user won't be able to edit it in edit mode (maybe there is a better approach, for now we just do this)
            const displaySelection = selectedOption ? selectedOption?.displayKey : `<EMPTY>`;
            return html`<tmn-form-group
                ><label>${displayLabel}:</label><span>${displaySelection}</span></tmn-form-group
            >`;
        }
        return html`<tmn-radio-group row @tmn-radio-group-value-changed=${this.handleRadioChanged}>
            ${dataForOptions.map((opt) => this.renderRadio(opt))}
        </tmn-radio-group>`;
    }

    preventPropagation(e) {
        // stop radio group listening to every click
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
    }

    renderRadio({ name, displayKey }) {
        const { value } = this;
        const checked = value === name;
        return html`<tmn-radio color="primary" value=${name} .checked=${checked}
            >${displayKey}</tmn-radio
        >`;
    }

    handleRadioChanged(e) {
        this.preventPropagation(e);
        const { path } = this;
        const { detail } = e;
        const { value } = detail;
        this.actions.setStagedEditByPath(path, value);
    }
}

customElements.define('form-element-radio-group', FormElementRadioGroup);
